import React, { useState, useEffect } from "react";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "../../../assets/scss/prompts.scss";
import "bootstrap-daterangepicker/daterangepicker.css";
import { useHistory } from "react-router-dom";
import Repository from "../../../configs/axios/repository";
import Spinner from "../../../@core/components/spinner/Fallback-spinner";
import { Card, CardBody, Row, Col } from "reactstrap";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  convertFromHTML,
  convertToRaw,
  EditorState,
  ContentState,
} from "draft-js";

import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "rgba(243, 242, 247, 1)" : "white",
    color: "black",
    cursor: "pointer",
  }),
};
let options = [
  {
    value: "flashcard",
    label: "Flashcard",
  },
  {
    value: "choice",
    label: "Choice Test",
  },
  {
    value: "written",
    label: "Written Test",
  },
  {
    value: "summerize",
    label: "Summerize Prompt",
  },
];
let modelOptions = [
  {
    value: "gpt-4o",
    label: "GPT-4o",
  },
  {
    value: "gpt-4-turbo",
    label: "GPT-4 Turbo",
  },

  {
    value: "gpt-3.5-turbo",
    label: "GPT-3.5 Turbo",
  },
];

const Prompt = (props) => {
  const history = useHistory();
  const [loadingData, setLoadingData] = useState(false);
  const [promptText, setPromptText] = useState("");
  const [selectedPrompt, setSelectedPrompt] = useState(options[0]);
  const [prompts, setPrompts] = useState(null);
  const [gptModel, setGptModel] = useState(null);
  const [password, setPassword] = useState(null);
  const [login, setLogin] = useState(null);
  const [isLogin, setIsLogin] = useState(false);
  // *****
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const onEditorStateChange = (newEditorState) => {
    setEditorState(newEditorState);
    const currentContent = newEditorState.getCurrentContent();
    const rawContentState = convertToRaw(currentContent);

    // const plainText = currentContent.getPlainText("\u0001");
    // Convert the raw content state to HTML
    const html = draftToHtml(rawContentState);

    setPromptText(html);
  };

  const findDefaultPrompts = async () => {
    const result = await Repository.findByEndPoint(
      `api/gpt/findDefaultPrompts`
    );

    if (result.data.success) {
      let model = modelOptions.find(
        (option) => option.value === result.data.data.gpt_model
      );

      setSelectedPrompt(selectedPrompt ? selectedPrompt : options[0]);
      setGptModel(gptModel ? gptModel : model);
      setPrompts(result.data.data);
    }
    setLoadingData(true);
  };

  const handleLogin = async (event) => {
    event.preventDefault();

    if (
      login == process.env.REACT_APP_PROMPT_LOGIN &&
      password == process.env.REACT_APP_PROMPT_PASSWORD
    ) {
      setIsLogin(true);
    } else {
      Swal.fire({
        title: "The login or password you entered is incorrect.",
        icon: "warning",
        confirmButtonColor: "#16285e",
      });
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    setLoadingData(false);
    let data = prompts;
    data.gpt_model = gptModel.value;

    if (selectedPrompt.value == "flashcard") {
      data.flashcard_prompt = promptText;
    } else if (selectedPrompt.value == "choice") {
      data.choice_prompt = promptText;
    } else if (selectedPrompt.value == "written") {
      data.written_prompt = promptText;
    } else if (selectedPrompt.value == "summerize") {
      data.summerize_prompt = promptText;
    }

    const result = await Repository.updateData(
      `api/gpt/updateGptPrompt/${prompts.id}`,
      data
    );

    if (result.data.success == true) {
      findDefaultPrompts();
    }
    setLoadingData(true);
  };

  const updateEditor = (htmlText) => {
    setEditorState("");
    const contentStateFromHTML = convertFromHTML(htmlText);
    const contentState = ContentState.createFromBlockArray(
      contentStateFromHTML.contentBlocks,
      contentStateFromHTML.entityMap
    );
    // Create a new EditorState using the ContentState
    const initialEditorState = EditorState.createWithContent(contentState);
    // Set the new EditorState as the current editor state
    setEditorState(initialEditorState);

    const currentContent = initialEditorState.getCurrentContent();
    const rawContentState = convertToRaw(currentContent);

    // const plainText = currentContent.getPlainText("\u0001");
    // Convert the raw content state to HTML
    const html = draftToHtml(rawContentState);
    setPromptText(html);
  };

  const checkSelectedType = () => {
    if (selectedPrompt.value == "flashcard") {
      updateEditor(prompts.flashcard_prompt);
    } else if (selectedPrompt.value == "choice") {
      updateEditor(prompts.choice_prompt);
    } else if (selectedPrompt.value == "written") {
      updateEditor(prompts.written_prompt);
    } else if (selectedPrompt.value == "summerize") {
      updateEditor(prompts.summerize_prompt);
    }
  };
  useEffect(() => {
    findDefaultPrompts();
  }, []);

  useEffect(() => {
    if (prompts && selectedPrompt) {
      checkSelectedType();
    }
  }, [selectedPrompt, prompts]);
  return loadingData ? (
    <div className="mt-4">
      <div className="d-flex justify-content-between">
        <div className="clidrenDivCompakt testH1">
          <div className="mt-4 ">
            <h1 className="noteTitle">
              {isLogin ? "ChatGPt Prompts" : "Sign In"}
            </h1>
          </div>
        </div>
      </div>
      <CardBody>
        <div>
          {isLogin ? (
            <div>
              <Row>
                <Col xl="3" md="6" sm="12">
                  <Select
                    isSearchable={false}
                    placeholder="Select Prompt Type*"
                    styles={customStyles}
                    maxMenuHeight={250}
                    className="react-select selectPrompt  "
                    classNamePrefix="select"
                    isClearable={false}
                    options={options}
                    onChange={(val) => {
                      setSelectedPrompt(val);
                    }}
                    defaultValue={selectedPrompt}
                  />
                </Col>
              </Row>

              <form onSubmit={handleSubmit}>
                <Row>
                  <Col xl="3" md="6" sm="12">
                    <Select
                      isSearchable={false}
                      placeholder="Select GPT Model*"
                      styles={customStyles}
                      maxMenuHeight={250}
                      className="react-select  mt-3 selectModel"
                      classNamePrefix="select"
                      isClearable={false}
                      options={modelOptions}
                      onChange={(val) => {
                        setGptModel(val);
                      }}
                      defaultValue={gptModel}
                    />
                  </Col>

                  <Col xl="12" md="12" sm="12">
                    <div className="tabMenuCreateNote">
                      <div className="tabs mt-3"></div>
                      <div className="mt-3">
                        <span>
                          {promptText?.length}
                          /200000
                        </span>
                      </div>
                    </div>

                    <Editor
                      editorState={editorState}
                      onEditorStateChange={onEditorStateChange}
                      toolbarClassName="toolbarClassName"
                      wrapperClassName="wrapperClassName"
                      editorClassName="editorPrompt"
                      placeholder="Your prompt*"
                    />
                  </Col>
                  <Col xl="12" md="12" sm="12">
                    <div className="testBtn mt-1 mb-4">
                      <button
                        onClick={() => {
                          history.push({
                            pathname: "/home",
                          });
                        }}
                        type="button"
                        className="btnOkTest"
                      >
                        Back
                      </button>
                      <button type="submit" className="btnNextTest">
                        Save
                      </button>
                    </div>
                  </Col>
                </Row>
              </form>
            </div>
          ) : (
            <form onSubmit={handleLogin}>
              <Row className="loginPrompt">
                <Col xl="4" md="6" sm="12">
                  <input
                    placeholder="Login"
                    className="gptModel"
                    type="text"
                    onChange={(e) => {
                      setLogin(e.target.value);
                    }}
                  />
                </Col>

                <Col xl="4" md="6" sm="12">
                  <input
                    type="password"
                    placeholder="Password"
                    className="gptModel"
                    onChange={(e) => {
                      setPassword(e.target.value);
                    }}
                  />
                </Col>

                <Col xl="12" md="12" sm="12">
                  <div className="testBtn mt-1 mb-4">
                    <button
                      onClick={() => {
                        history.push({
                          pathname: "/home",
                        });
                      }}
                      type="button"
                      className="btnOkTest"
                    >
                      Back
                    </button>
                    <button type="submit" className="btnNextTest">
                      Sign in
                    </button>
                  </div>
                </Col>
              </Row>
            </form>
          )}
        </div>
      </CardBody>
    </div>
  ) : (
    <Spinner spiner={true} />
  );
};

export default Prompt;
